import { AttachmentList as UiAttachmentList } from '@faceup/ui'
import type { ComponentProps } from 'react'
import { AttachmentRedact, useRedaction } from '../Redaction'

type AttachmentListProps = ComponentProps<typeof UiAttachmentList>

export const AttachmentList = (props: AttachmentListProps) => {
  const { isRedactionActive } = useRedaction()
  return (
    <UiAttachmentList
      {...props}
      attachments={props.attachments}
      config={{
        ...props.config,
        onDownload: isRedactionActive ? null : props.config.onDownload,
        renderFileName: (children, attachment) => (
          <AttachmentRedact
            text={attachment.name}
            type={{
              id: attachment.id,
              type: 'attachments',
            }}
          >
            {children}
          </AttachmentRedact>
        ),
        isDownloadDisabled: isRedactionActive,
      }}
    />
  )
}
